import { render, staticRenderFns } from "./MtrlEditAbout.vue?vue&type=template&id=2b97132a&scoped=true&"
import script from "./MtrlEditAbout.vue?vue&type=script&lang=js&"
export * from "./MtrlEditAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b97132a",
  null
  
)

export default component.exports